import PropTypes from 'prop-types'

import { noop, range } from 'utils'
import NoneAnchor from 'components/NoneAnchor'

const DEFAULT_PAGE_SIZE = 10
const DEFAULT_LIMIT_SIZE = 10

const PageItem = ({
  disabled = false,
  active = false,
  onClick = noop,
  children,
}) => {
  const Tag = disabled ? 'span' : active ? 'em' : NoneAnchor
  return (
    <Tag className="num_paging" onClick={disabled ? noop : onClick}>
      {active && <span className="screen_out">현재페이지</span>}
      {children}
    </Tag>
  )
}

PageItem.propTypes = {
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
}

const Pagination = ({
  current,
  total = Number.MAX_SAFE_INTEGER,
  size = DEFAULT_PAGE_SIZE,
  limit = DEFAULT_LIMIT_SIZE,
  hideWhenSinglePage = false,
  disabled,
  onChange,
}) => {
  const firstPage = 0
  const lastPage = Math.max(Math.ceil(total / size) - 1, 0)
  const safeCurrent = Math.min(current, lastPage)
  const from = Math.floor(safeCurrent / limit) * limit
  const to = Math.min(lastPage, from + limit - 1)
  const prevPage = Math.max(firstPage, from - 1)
  const nextPage = Math.min(lastPage, to + 1)

  return (
    (lastPage === firstPage && hideWhenSinglePage) ||
    total === 0 || (
      <>
        <PageItem
          disabled={disabled || from <= firstPage}
          onClick={() => onChange(firstPage)}>
          <span className="ico_comm ico_prevs">맨처음</span>
        </PageItem>

        <PageItem
          disabled={disabled || from <= firstPage}
          onClick={() => onChange(prevPage)}>
          <span className="ico_comm ico_prev">이전</span>
        </PageItem>

        {range(from, to + 1).map(num => (
          <PageItem
            disabled={disabled}
            key={num}
            active={num === safeCurrent}
            onClick={() => onChange(num)}>
            {num + 1}
          </PageItem>
        ))}

        <PageItem
          disabled={disabled || to >= lastPage}
          onClick={() => onChange(nextPage)}>
          <span className="ico_comm ico_next">
            다음 {to}, {lastPage}
          </span>
        </PageItem>

        <PageItem
          disabled={disabled || to >= lastPage}
          onClick={() => onChange(lastPage)}>
          <span className="ico_comm ico_nexts">맨끝</span>
        </PageItem>
      </>
    )
  )
}

Pagination.propTypes = {
  current: PropTypes.number.isRequired,
  hideWhenSinglePage: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  size: PropTypes.number,
  limit: PropTypes.number,
  total: PropTypes.number,
  disabled: PropTypes.bool,
}

export default Pagination
